(function () {
  "use strict";

  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  var VERSION = "2026-07-20";
  var STORAGE_KEY = "pb_creator_attribution_v1";
  var SYNC_KEY = "pb_creator_attribution_last_sync_v1";
  var CLEANUP_KEY = "pb_creator_attribution_cleanup_v1";
  var COOKIE_DAYS = 30;
  var MAX_TOUCHES = 12;
  var MAX_ATTR_LENGTH = 1000;
  var REF_PARAM_NAMES = ["ref", "gfp_ref", "aff", "wpam_id", "click_id"];
  var COUPON_PARAM_NAMES = ["pb_coupon", "coupon", "discount", "discount_code"];
  var ATTR_URL_PARAM_NAMES = [
    "ref",
    "gfp_ref",
    "aff",
    "wpam_id",
    "click_id",
    "sub_id",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "pb_creator",
    "creator",
    "pb_coupon",
    "coupon",
    "discount",
    "discount_code"
  ];
  var RESERVED_ROOT_PATHS = {
    "": true,
    "account": true,
    "apps": true,
    "blogs": true,
    "cart": true,
    "checkout": true,
    "collections": true,
    "contact": true,
    "discount": true,
    "pages": true,
    "policies": true,
    "products": true,
    "search": true
  };
  var DEFAULT_COUPON_MAP = {
    BOLODEMURANGO: "HERBERTHDASILVA"
  };

  function init() {
    captureCreatorTouch();
    syncCartAttributes({ force: false });
    bindCartSync();
    exposeDebugTools();
  }

  function captureCreatorTouch() {
    var state = loadState();
    var touch = touchFromLocation(window.location);

    if (!touch) {
      return state;
    }

    state = mergeTouch(state, touch);
    saveState(state);
    return state;
  }

  function touchFromLocation(locationObj) {
    var params = new URLSearchParams(locationObj.search || "");
    var ref = normalizeRef(firstParam(params, REF_PARAM_NAMES) || referralCodeFromPath(locationObj.pathname));
    var coupon = normalizeRef(firstParam(params, COUPON_PARAM_NAMES) || discountCodeFromPath(locationObj.pathname));
    var subId = normalizeCreatorToken(params.get("sub_id"));
    var medium = normalizeCreatorToken(params.get("utm_medium"));
    var utmSource = normalizeCreatorToken(params.get("utm_source"));
    var creator = normalizeCreatorToken(params.get("pb_creator") || params.get("creator"));
    var source = deriveCreatorSource({
      ref: ref,
      source: utmSource,
      subId: subId,
      creator: creator
    });

    var isCreatorTouch = (
      looksLikeCreator(source) ||
      looksLikeCreator(subId) ||
      medium === "affiliate" ||
      !!ref ||
      !!coupon
    );
    if (!isCreatorTouch || (!source && !ref && !coupon)) {
      return null;
    }

    if (!source && coupon) {
      source = "creator_" + normalizeCode(coupon);
    }
    if (!ref && coupon) {
      ref = coupon;
    }

    var couponMap = configuredCouponMap();
    var selectedCoupon = coupon || couponMap[ref] || ref;

    return normalizeTouch({
      source: source,
      medium: medium || "affiliate",
      ref: ref,
      coupon: selectedCoupon,
      sub_id: subId,
      campaign: clean(params.get("utm_campaign")),
      content: clean(params.get("utm_content")),
      term: clean(params.get("utm_term")),
      landing_page: stripQuery(locationObj.origin + locationObj.pathname),
      landing_url: attributionUrl(locationObj),
      referrer_url: stripQuery(document.referrer || ""),
      seen_at: new Date().toISOString()
    });
  }

  function deriveCreatorSource(parts) {
    if (looksLikeCreator(parts.source)) {
      return normalizeCreatorToken(parts.source);
    }
    if (looksLikeCreator(parts.subId)) {
      return normalizeCreatorToken(parts.subId);
    }
    if (parts.creator) {
      return normalizeCreatorSource(parts.creator);
    }
    if (parts.ref) {
      return normalizeCreatorSource(parts.ref);
    }
    if (parts.source) {
      return normalizeCreatorToken(parts.source);
    }
    return "";
  }

  function mergeTouch(state, touch) {
    var next = normalizeState(state);
    var existing = null;
    var i;

    for (i = 0; i < next.touches.length; i += 1) {
      if (sameCreatorTouch(next.touches[i], touch)) {
        existing = next.touches[i];
        break;
      }
    }

    if (existing) {
      existing.source = touch.source || existing.source;
      existing.medium = touch.medium || existing.medium;
      existing.ref = touch.ref || existing.ref;
      existing.coupon = touch.coupon || existing.coupon;
      existing.sub_id = touch.sub_id || existing.sub_id;
      existing.campaign = touch.campaign || existing.campaign;
      existing.content = touch.content || existing.content;
      existing.term = touch.term || existing.term;
      existing.last_landing_page = touch.landing_page || existing.last_landing_page;
      existing.last_landing_url = touch.landing_url || existing.last_landing_url;
      existing.referrer_url = touch.referrer_url || existing.referrer_url;
      existing.last_seen_at = touch.seen_at || existing.last_seen_at;
    } else {
      next.touches.push(touch);
    }

    next.touches = next.touches.slice(Math.max(0, next.touches.length - MAX_TOUCHES));
    next.first = next.touches[0] || touch;
    next.last = latestTouch(next.touches) || touch;
    next.touch_count = (Number(next.touch_count) || 0) + 1;
    next.touch_sources = appendTouchSource(next.touch_sources, touch.source);
    next.version = VERSION;
    next.expires_at = addDaysIso(COOKIE_DAYS);
    next.attribution_id = next.attribution_id || attributionId();
    return next;
  }

  function sameCreatorTouch(left, right) {
    var leftKey = normalizeRef(left.ref || left.coupon || left.source);
    var rightKey = normalizeRef(right.ref || right.coupon || right.source);
    return leftKey && leftKey === rightKey;
  }

  function normalizeState(state) {
    var touches = [];
    var first;
    var last;

    if (state && typeof state === "object") {
      if (Array.isArray(state.touches)) {
        state.touches.forEach(function (touch) {
          var normalized = normalizeTouch(touch);
          if (normalized) {
            touches.push(normalized);
          }
        });
      } else {
        first = normalizeTouch(state.first);
        last = normalizeTouch(state.last);
        if (first) {
          touches.push(first);
        }
        if (last && !sameCreatorTouch(first || {}, last)) {
          touches.push(last);
        }
      }
    }

    if (state && state.expires_at && Date.parse(state.expires_at) < Date.now()) {
      return emptyState(true);
    }

    first = touches[0] || null;
    last = latestTouch(touches) || first;
    return {
      version: clean((state && state.version) || VERSION) || VERSION,
      attribution_id: clean((state && state.attribution_id) || "") || attributionId(),
      expires_at: clean((state && state.expires_at) || "") || addDaysIso(COOKIE_DAYS),
      first: first,
      last: last,
      touch_count: Number(state && state.touch_count) || touches.length,
      touch_sources: Array.isArray(state && state.touch_sources)
        ? state.touch_sources
        : touches.map(function (touch) { return touch.source; }),
      touches: touches
    };
  }

  function emptyState(markForCleanup) {
    if (markForCleanup) {
      try {
        window.localStorage.setItem(CLEANUP_KEY, "1");
      } catch (error) {
        // Ignore storage failures.
      }
    }
    return {
      version: VERSION,
      attribution_id: "",
      expires_at: "",
      first: null,
      last: null,
      touch_count: 0,
      touch_sources: [],
      touches: []
    };
  }

  function normalizeTouch(touch) {
    if (!touch || typeof touch !== "object") {
      return null;
    }
    var ref = normalizeRef(touch.ref || touch.creator_ref);
    var coupon = normalizeRef(touch.coupon || touch.creator_coupon);
    var source = normalizeCreatorToken(touch.source);
    if (!source && ref) {
      source = normalizeCreatorSource(ref);
    }
    if (!source && coupon) {
      source = normalizeCreatorSource(coupon);
    }
    if (!source && !ref && !coupon) {
      return null;
    }

    return {
      source: source,
      medium: normalizeCreatorToken(touch.medium) || "affiliate",
      ref: ref,
      coupon: coupon || ref,
      sub_id: normalizeCreatorToken(touch.sub_id),
      campaign: clean(touch.campaign),
      content: clean(touch.content),
      term: clean(touch.term),
      landing_page: stripQuery(clean(touch.landing_page)),
      landing_url: clean(touch.landing_url) || stripQuery(clean(touch.landing_page)),
      last_landing_page: stripQuery(clean(touch.last_landing_page || touch.landing_page)),
      last_landing_url: clean(touch.last_landing_url || touch.landing_url),
      referrer_url: stripQuery(clean(touch.referrer_url)),
      seen_at: clean(touch.seen_at || touch.first_seen_at),
      first_seen_at: clean(touch.first_seen_at || touch.seen_at),
      last_seen_at: clean(touch.last_seen_at || touch.seen_at || touch.first_seen_at)
    };
  }

  function latestTouch(touches) {
    var latest = null;
    touches.forEach(function (touch) {
      if (!latest) {
        latest = touch;
        return;
      }
      var latestTime = Date.parse(latest.last_seen_at || latest.seen_at || "") || 0;
      var touchTime = Date.parse(touch.last_seen_at || touch.seen_at || "") || 0;
      if (touchTime >= latestTime) {
        latest = touch;
      }
    });
    return latest;
  }

  function appendTouchSource(existing, source) {
    var sources = Array.isArray(existing) ? existing.slice(0) : [];
    var value = clean(source);
    if (value) {
      sources.push(value);
    }
    return sources.filter(Boolean).slice(Math.max(0, sources.length - MAX_TOUCHES));
  }

  function syncCartAttributes(options) {
    var opts = options || {};
    var attrs = buildCartAttributes();
    var needsCleanup = readLocal(CLEANUP_KEY) === "1";

    if (!attrs && !needsCleanup) {
      return Promise.resolve(false);
    }

    var payloadAttrs = attrs || buildEmptyCartAttributes();
    var signature = JSON.stringify(payloadAttrs);
    if (!needsCleanup && !opts.force && readLocal(SYNC_KEY) === signature) {
      return Promise.resolve(true);
    }

    return fetch(shopifyRoot() + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ attributes: payloadAttrs })
    }).then(function (response) {
      if (!response.ok) {
        return false;
      }
      if (attrs) {
        writeLocal(SYNC_KEY, signature);
        removeLocal(CLEANUP_KEY);
      } else {
        removeLocal(SYNC_KEY);
        removeLocal(CLEANUP_KEY);
      }
      return true;
    }).catch(function () {
      return false;
    });
  }

  function buildCartAttributes() {
    var state = normalizeState(loadState());
    if (!state.first) {
      return null;
    }
    var first = state.first;
    var last = state.last || state.first;
    var creatorRefs = state.touches.map(function (touch) {
      return touch.ref || touch.coupon || normalizeRef(touch.source.replace(/^creator_/, ""));
    }).filter(Boolean);
    var summary = "first=" + (first.ref || first.source)
      + "; last=" + (last.ref || last.source)
      + "; coupon=" + (last.coupon || last.ref || "")
      + "; content=" + (last.content || "");

    return compactAttributes({
      "PB Attribution Summary": summary,
      "PB Attribution ID": state.attribution_id,
      "pb_attribution_summary": summary,
      "_pb_attr_version": VERSION,
      "_pb_attribution_id": state.attribution_id,
      "_pb_first_creator_source": first.source,
      "_pb_first_creator_medium": first.medium,
      "_pb_first_ref": first.ref,
      "_pb_first_sub_id": first.sub_id,
      "_pb_first_campaign": first.campaign,
      "_pb_first_content": first.content,
      "_pb_first_landing_page": first.landing_page,
      "_pb_first_landing_url": first.landing_url,
      "_pb_first_seen_at": first.first_seen_at || first.seen_at,
      "_pb_last_creator_source": last.source,
      "_pb_last_creator_medium": last.medium,
      "_pb_last_ref": last.ref || last.coupon,
      "_pb_last_sub_id": last.sub_id,
      "_pb_last_campaign": last.campaign,
      "_pb_last_content": last.content,
      "_pb_last_landing_page": last.last_landing_page || last.landing_page,
      "_pb_last_landing_url": last.last_landing_url || last.landing_url,
      "_pb_last_seen_at": last.last_seen_at || last.seen_at,
      "_pb_touch_count": String(state.touch_count || state.touches.length || 1),
      "_pb_touch_sources": state.touch_sources.join(","),
      "_pb_creator_touch_count": String(state.touches.length || 1),
      "_pb_first_creator_ref": first.ref || first.coupon,
      "_pb_last_creator_ref": last.ref || last.coupon,
      "_pb_creator_refs": creatorRefs.join(","),
      "_pb_selected_creator_ref": last.ref || last.coupon,
      "_pb_selected_creator_coupon": last.coupon || last.ref,
      "_pb_last_utm_source": last.source,
      "_pb_last_utm_medium": last.medium,
      "_pb_last_utm_campaign": last.campaign,
      "_pb_last_utm_content": last.content
    });
  }

  function buildEmptyCartAttributes() {
    return {
      "PB Attribution Summary": null,
      "PB Attribution ID": null,
      "pb_attribution_summary": null,
      "_pb_attr_version": null,
      "_pb_attribution_id": null,
      "_pb_first_creator_source": null,
      "_pb_first_creator_medium": null,
      "_pb_first_ref": null,
      "_pb_first_sub_id": null,
      "_pb_first_campaign": null,
      "_pb_first_content": null,
      "_pb_first_landing_page": null,
      "_pb_first_landing_url": null,
      "_pb_first_seen_at": null,
      "_pb_last_creator_source": null,
      "_pb_last_creator_medium": null,
      "_pb_last_ref": null,
      "_pb_last_sub_id": null,
      "_pb_last_campaign": null,
      "_pb_last_content": null,
      "_pb_last_landing_page": null,
      "_pb_last_landing_url": null,
      "_pb_last_seen_at": null,
      "_pb_touch_count": null,
      "_pb_touch_sources": null,
      "_pb_creator_touch_count": null,
      "_pb_first_creator_ref": null,
      "_pb_last_creator_ref": null,
      "_pb_creator_refs": null,
      "_pb_selected_creator_ref": null,
      "_pb_selected_creator_coupon": null,
      "_pb_last_utm_source": null,
      "_pb_last_utm_medium": null,
      "_pb_last_utm_campaign": null,
      "_pb_last_utm_content": null
    };
  }

  function bindCartSync() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.matches) {
        return;
      }
      var action = String(form.getAttribute("action") || "");
      if (action.indexOf("/cart") >= 0 || action.indexOf("/cart/add") >= 0 || form.querySelector("[name='checkout']")) {
        syncCartAttributes({ force: true });
      }
    }, true);

    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest("a,button,input")
        : null;
      if (!target) {
        return;
      }
      var href = String(target.getAttribute("href") || "");
      var name = String(target.getAttribute("name") || "").toLowerCase();
      var type = String(target.getAttribute("type") || "").toLowerCase();
      var text = String(target.textContent || "").toLowerCase();
      if (
        href.indexOf("/checkout") >= 0 ||
        name === "checkout" ||
        type === "submit" ||
        text.indexOf("checkout") >= 0 ||
        text.indexOf("finalizar compra") >= 0 ||
        text.indexOf("adicionar ao carrinho") >= 0 ||
        text.indexOf("add to cart") >= 0
      ) {
        syncCartAttributes({ force: true });
      }
    }, true);

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        syncCartAttributes({ force: false });
      }
    });

    window.addEventListener("pagehide", function () {
      syncCartAttributes({ force: false });
    });
  }

  function exposeDebugTools() {
    window.PlayBearCreatorAttribution = {
      read: loadState,
      capture: captureCreatorTouch,
      buildCartAttributes: buildCartAttributes,
      sync: function () {
        return syncCartAttributes({ force: true });
      },
      clear: function () {
        removeLocal(STORAGE_KEY);
        removeLocal(SYNC_KEY);
        removeLocal(CLEANUP_KEY);
      }
    };
  }

  function attributionUrl(locationObj) {
    var params = new URLSearchParams(locationObj.search || "");
    var safeParams = [];
    ATTR_URL_PARAM_NAMES.forEach(function (name) {
      var value = clean(params.get(name));
      if (value) {
        safeParams.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
      }
    });
    return locationObj.origin + locationObj.pathname + (safeParams.length ? "?" + safeParams.join("&") : "");
  }

  function referralCodeFromPath(pathname) {
    var path = decodePath(pathname).replace(/^\/+|\/+$/g, "");
    if (!path || path.indexOf("/") >= 0) {
      return "";
    }
    var lower = path.toLowerCase();
    if (RESERVED_ROOT_PATHS[lower] || !/^[a-z0-9][a-z0-9_-]{2,40}$/i.test(path)) {
      return "";
    }
    return normalizeRef(path);
  }

  function discountCodeFromPath(pathname) {
    var match = decodePath(pathname).match(/^\/discount\/([^/]+)/i);
    return match ? normalizeRef(match[1]) : "";
  }

  function firstParam(params, names) {
    for (var i = 0; i < names.length; i += 1) {
      var value = clean(params.get(names[i]));
      if (value) {
        return value;
      }
    }
    return "";
  }

  function looksLikeCreator(value) {
    var cleanValue = normalizeCreatorToken(value);
    return cleanValue.indexOf("creator_") === 0 || cleanValue.indexOf("affiliate_") === 0;
  }

  function normalizeCreatorSource(value) {
    var code = normalizeCode(value);
    if (!code) {
      return "";
    }
    return code.indexOf("creator_") === 0 || code.indexOf("affiliate_") === 0
      ? code
      : "creator_" + code;
  }

  function normalizeCreatorToken(value) {
    return clean(value).toLowerCase().replace(/[^a-z0-9_-]+/g, "_").replace(/^_+|_+$/g, "");
  }

  function normalizeCode(value) {
    return clean(value).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  }

  function normalizeRef(value) {
    return clean(value).replace(/[^a-zA-Z0-9_-]+/g, "").toUpperCase();
  }

  function stripQuery(value) {
    return clean(value).split("#", 1)[0].split("?", 1)[0];
  }

  function clean(value) {
    return String(value || "").trim().slice(0, MAX_ATTR_LENGTH);
  }

  function compactAttributes(attrs) {
    var out = {};
    Object.keys(attrs).forEach(function (key) {
      var value = attrs[key];
      out[key] = value == null ? null : clean(value);
    });
    return out;
  }

  function configuredCouponMap() {
    var configured = window.PlayBearCreatorCouponMap || {};
    var map = {};
    Object.keys(DEFAULT_COUPON_MAP).forEach(function (key) {
      map[normalizeRef(key)] = normalizeRef(DEFAULT_COUPON_MAP[key]);
    });
    Object.keys(configured).forEach(function (key) {
      map[normalizeRef(key)] = normalizeRef(configured[key]);
    });
    return map;
  }

  function attributionId() {
    return "pb_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  function addDaysIso(days) {
    var date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString();
  }

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  function decodePath(pathname) {
    try {
      return decodeURIComponent(String(pathname || ""));
    } catch (error) {
      return String(pathname || "");
    }
  }

  function saveState(state) {
    var normalized = normalizeState(state);
    if (!normalized.first) {
      return;
    }
    var serialized = JSON.stringify(normalized);
    writeLocal(STORAGE_KEY, serialized);
    writeCookie(STORAGE_KEY, serialized, COOKIE_DAYS);
    removeLocal(CLEANUP_KEY);
    removeLocal(SYNC_KEY);
  }

  function loadState() {
    var raw = readLocal(STORAGE_KEY) || readCookie(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    try {
      var state = normalizeState(JSON.parse(raw));
      if (!state.first) {
        removeLocal(STORAGE_KEY);
        removeLocal(SYNC_KEY);
        return null;
      }
      return state;
    } catch (error) {
      removeLocal(STORAGE_KEY);
      removeLocal(SYNC_KEY);
      return null;
    }
  }

  function readLocal(key) {
    try {
      return window.localStorage.getItem(key) || "";
    } catch (error) {
      return "";
    }
  }

  function writeLocal(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // localStorage can be disabled in private browsing.
    }
  }

  function removeLocal(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // localStorage can be disabled in private browsing.
    }
  }

  function writeCookie(name, value, days) {
    var maxAge = Math.max(1, days) * 24 * 60 * 60;
    document.cookie = name + "=" + encodeURIComponent(value)
      + "; Max-Age=" + maxAge
      + "; Path=/; SameSite=Lax; Secure";
  }

  function readCookie(name) {
    var prefix = name + "=";
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i += 1) {
      var item = parts[i].trim();
      if (item.indexOf(prefix) === 0) {
        return decodeURIComponent(item.slice(prefix.length));
      }
    }
    return "";
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();